import { getLoginState, tosLogin } from '@features/loginSlice';
import { ROUTES } from '@routes/constants';
import { useAppDispatch } from '@store';
import { Controller, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button, { BUTTON_SIZE, BUTTON_TYPE } from '@components/Button';
import Spinner, { SPINNER_TYPE } from '@components/Spinner';
import SubHeading from '@components/SubHeading';
import TextInput from '@components/TextInput';

import SmileIcon from '@assets/BigIcons/Smile';

import styles from './styles.module.scss';

interface FormValues {
  username: string;
  password: string;
}

const LoginForm = () => {
  const { handleSubmit, control } = useForm<FormValues>({ mode: 'onBlur' });
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector(getLoginState);

  const onSubmit = (values: FormValues) => {
    dispatch(tosLogin(values)).then(() => {
      navigate(ROUTES.PROGRAMS);
    });
  };

  return (
    <div className={styles.container}>
      <h2>Log in to TranslationOS</h2>
      <SubHeading icon={<SmileIcon />} description="Welcome back, please put your login credentials below to access the app." />

      <form onSubmit={handleSubmit(onSubmit)}>
        <fieldset>
          <Controller
            rules={{
              required: 'This field is mandatory',
            }}
            control={control}
            name="username"
            render={({ field: { name, onChange, onBlur, value }, fieldState: { error } }) => {
              return (
                <TextInput
                  onBlur={onBlur}
                  name={name}
                  label="Customer ID"
                  placeholder="E.g. webelieveinhumans"
                  value={value}
                  onChange={onChange}
                  error={error?.message}
                />
              );
            }}
          />
        </fieldset>
        <fieldset>
          <Controller
            rules={{
              required: 'This field is mandatory',
            }}
            control={control}
            name="password"
            render={({ field: { name, onChange, onBlur, value }, fieldState: { error } }) => {
              return (
                <TextInput
                  isPassword
                  onBlur={onBlur}
                  name={name}
                  label="Password"
                  placeholder="••••••••••••"
                  value={value}
                  onChange={onChange}
                  error={error?.message}
                />
              );
            }}
          />
        </fieldset>
        <fieldset>
          <Button fullWidth type={BUTTON_TYPE.PRIMARY} size={BUTTON_SIZE.BIG} onClick={handleSubmit(onSubmit)} htmlType="submit">
            {loading ? <Spinner type={SPINNER_TYPE.LIGHT} size={20} /> : 'Login to continue'}
          </Button>
          {error && <p className={styles.error}>{error}</p>}
        </fieldset>
      </form>
    </div>
  );
};

export default LoginForm;
